import { render } from "./Underline.vue?vue&type=template&id=19a98911"
import script from "./Underline.vue?vue&type=script&lang=ts"
export * from "./Underline.vue?vue&type=script&lang=ts"
script.render = render

export default script